export const ImagesLoader = Object({
    //About Area
    AAFirst : require('../../../images/about/about.jpg'),
    //Gallery Area
    First : require('../../../images/gallery/1.png'),
    Second : require('../../../images/gallery/2.png'),
    Third : require('../../../images/gallery/3.png'),
    Fourth : require('../../../images/gallery/4.png'),
    Fifth : require('../../../images/gallery/5.png'),
    //About Wrap
    AW_First : require('../../../images/svg_icon/controls.svg'),
    AW_Second : require('../../../images/svg_icon/bar-chart.svg'),
    AW_Third : require('../../../images/svg_icon/puzzle.svg'),
    //Financial Solution Area
    FSA_first : require('../../../images/home/bg09.jpg'),
    //Service Detail Area //SINGLE SERVICE
    about:{
        'background': 'bradcam_area breadcam_bg_4 about'
    },
    contacts: {
        'background': 'bradcam_area breadcam_bg_4 contact'
    },
    services: {
        // marketconnect: require('../../../images/services/marketconnect.jpg'),
        marketconnectweb: require('../../../images/services/web_services.jpg'),
        client: require('../../../images/services/client_services.jpg'),
        // mifid: require('../../../images/services/mifid.jpg'),
        feed: require('../../../images/services/WndEITS_services.jpg'),
        finsite: require('../../../images/services/finsite_services.jpg'),
        investorrelations: require('../../../images/services/invrelations.jpg'),
        webservices: require('../../../images/services/mifid.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 services'
    },
    marketconnect:{
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 marketconnect'
    },
    web: {
        SDA_first: require('../../../images/services/mcwp3_book.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 web'
    },
    itp: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 marketconnect'
    },
    client: {
        SDA_first: require('../../../images/services/client_book.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 client'
    },
    compliancewks: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 compliancewks'
    },
    datistorici: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 datistorici'
    },
    bookconsolidato: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 bookconsolidato'
    },
    bestexecutionengine: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 bestexecutionengine'
    },
    otcmarketplace: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 otcmarketplace'
    },
    ftp: {
        SDA_first: require('../../../images/services/ftp.png'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 ftp'
    },
    api: {
        SDA_first: require('../../../images/services/WndEITS.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 api'
    },
    webservices: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 webservices'
    },
    basic: {
        // SDA_first: require('../../../images/services/person-writing-on-notebook-669615.jpg'),
        SDA_first: require('../../../images/services/basic.png'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 basic'
    },
    premium: {
        // SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_first: require('../../../images/services/premium.png'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 premium'
    },
    full: {
        // SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_first: require('../../../images/services/full.png'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 full'
    },
    investorrelations: {
        SDA_first: require('../../../images/home/bg01.jpg'),
        SDA_second: require('../../../images/services/banner_bottom.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 investorrelations'
    },
    //Services Detail Area //MULTIPLE SERVICES
    mifid:{
        SDA_first: require('../../../images/services/marketconnect.jpg'),
        SDA_second: require('../../../images/home/explore/web.jpg'),
        SDA_third: require('../../../images/services/client.jpg'),
        SDA_fourth: require('../../../images/home/explore/feed.jpg'),
        SDA_fifth: require('../../../images/services/mifid.jpg'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 mifid'
    },
    feed: {
        SDA_first: require('../../../images/services/ftp.png'),
        SDA_second: require('../../../images/services/WndEITS.jpg'),
        
        //class trick
        'background': 'bradcam_area breadcam_bg_4 feed'
    },
    finsite: {
        SDA_first: require('../../../images/services/finsite_basic.png'),
        SDA_second: require('../../../images/services/finsite_premium.png'),
        SDA_third: require('../../../images/services/finsite_full.png'),
        // SDA_first: require('../../../images/services/basic.png'),
        // SDA_second: require('../../../images/services/premium.png'),
        // SDA_third: require('../../../images/services/full.png'),
        //class trick
        'background': 'bradcam_area breadcam_bg_4 finsite'
    }
})